import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { isEmpty } from 'lodash';

// Components
import ConnectedListingDetail from '../../../../../cards/components/CardListing/ListingDetail/ListingDetail';

// Actions
import {
  getRelatedCardsFromSuite,
  setInitialVariationColor,
  unMountRelatedCards
} from '../../../../../cards/actions/cardCatalogActions';
import { getByKeyV2, resetThemes } from '../../../../../actions/website/ThemeActions';

// Selectors
import {
  getRelatedCardsFromCurrentSuite,
  getSearchFilters
} from '../../../../../cards/selectors/cardCatalogSelector';

// Stylesheets
import './Cards.styles.less';

export class Cards extends Component {
  componentDidMount() {
    this.getCards();
  }

  componentDidUpdate(prevProps) {
    const { themeKey, themeGroup } = this.props;

    if (themeKey !== prevProps.themeKey || themeGroup.title !== prevProps.themeGroup.title) {
      this.getCards();
    }
  }

  componentWillUnmount() {
    this.props.unMountRelatedCardsFromSuite();
    this.props.unloadTheme();
  }

  getCards = () => {
    const { loadTheme, themeKey, themeGroup, onGetRelatedCardsFromSuite, unMountRelatedCardsFromSuite, fallbackDisplay } = this.props;

    // We need to call loadTheme in order to populate the themeGroup Object
    loadTheme(themeKey);

    if (themeGroup && themeGroup.title) {
      unMountRelatedCardsFromSuite();
      onGetRelatedCardsFromSuite(themeGroup.title).then((data) => {
        if (fallbackDisplay && isEmpty(data.payload.relatedCards.suites)) {
          fallbackDisplay();
        }
      });
    }
  };

  render() {
    const {
      relatedCards,
      lightView,
      isAdminView,
      onSetInitialVariationColor,
      initialVariationColor,
      relatedCardsFamilyName,
      searchFilters
    } = this.props;


    const basePlanningUrl = isAdminView ? '/wedding-planning/admin' : '/wedding-planning';

    const cardTypes = {
      SAVE_THE_DATE: {
        text: 'Save the Dates',
        path: `${basePlanningUrl}/save-the-date/shop`
      },
      INVITATION: {
        text: 'Invitations',
        path: `${basePlanningUrl}/invitations/shop`
      },
      THANK_YOU: {
        text: 'Thank You Cards',
        path: `${basePlanningUrl}/thank-you-cards/shop`
      },
      MENU: {
        text: 'Menus',
        path: `${basePlanningUrl}/menus/shop`
      },
      PROGRAM: {
        text: 'Programs',
        path: `${basePlanningUrl}/programs/shop`
      },
      DETAILS: {
        text: 'Enclosures Cards',
        path: `${basePlanningUrl}/enclosures/shop`
      }
    };


    if (isEmpty(relatedCards)) {
      return null;
    }

    return (
      <div className="mpr-cards">
        {relatedCards.map(card => (
          <div
            key={card.uuid}
            className="mpr-cards__list-item"
          >
            <ConnectedListingDetail
              card={card}
              family={relatedCardsFamilyName}
              filterColor={searchFilters.color}
              basePlanningUrl={basePlanningUrl}
              onSetInitialVariationColor={onSetInitialVariationColor}
              initialVariationColor={initialVariationColor}
              lightView={lightView}
            />
            {!lightView && (
              <div className="mpr-cards__link-wrapper">
                <Link to={cardTypes[card.type].path} className="mpr-cards__more-link">More {cardTypes[card.type].text} &gt;</Link>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

Cards.propTypes = {
  unMountRelatedCardsFromSuite: PropTypes.func,
  relatedCards: PropTypes.arrayOf(PropTypes.shape({})),
  onGetRelatedCardsFromSuite: PropTypes.func,
  onSetInitialVariationColor: PropTypes.func,
  initialVariationColor: PropTypes.string,
  lightView: PropTypes.bool,
  isAdminView: PropTypes.bool,
  fallbackDisplay: PropTypes.func,
  relatedCardsFamilyName: PropTypes.string,
  searchFilters: PropTypes.shape({
    color: PropTypes.string
  }),
  themeGroup: PropTypes.shape({
    title: PropTypes.string
  }),
  themeKey: PropTypes.string,
  loadTheme: PropTypes.func.isRequired,
  unloadTheme: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  relatedCards: getRelatedCardsFromCurrentSuite(state),
  searchFilters: getSearchFilters(state),
  themeGroup: state.website.themeListing.themeDetails,
  themeKey: state.wedding.theme.key
});

const mapDispatchToProps = dispatch => ({
  loadTheme: (themeKey) => {
    dispatch(getByKeyV2(themeKey));
  },
  unloadTheme: () => dispatch(resetThemes()),
  onGetRelatedCardsFromSuite: (familyName, initialColor) => dispatch(getRelatedCardsFromSuite(familyName, initialColor)),
  unMountRelatedCardsFromSuite: () => dispatch(unMountRelatedCards()),
  onSetInitialVariationColor: color => dispatch(setInitialVariationColor(color)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Cards);



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/Cards/Cards.jsx